import oneOf from '@/services/validation/defaultValidators/one_of'
import { isEmpty } from '@/services/validation/defaultValidators/utils'

const excludedValidator = (value: unknown, list: unknown[]) => {
  if (isEmpty(value)) {
    return true
  }

  return !oneOf(value, list)
}

export default excludedValidator
